import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { ReviewService } from 'src/app/services/common/review.service';
import { DeleteBoxComponent } from '../../delete-box/delete-box.component';

@Component({
  selector: 'app-complete-review',
  templateUrl: './complete-review.component.html',
  styleUrls: ['./complete-review.component.scss']
})
export class CompleteReviewComponent {

  selectedDocs: any[] = [];
  @Input() public Content: any;
  content: any;
  ReviewId: any;
  appCode:any;

  constructor(
    private reviewService: ReviewService,
    private commonService: CommonService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    if (this.Content.content !== null) {
      if (this.Content.content.ReviewId != null && this.Content.content.ReviewId != "" && this.Content.content.ReviewId != undefined) {
        this.ReviewId = this.Content.content.ReviewId;
        this.appCode= this.Content.content.applicationCode;
        if(this.Content.content.TaskType != null && this.Content.content.TaskType == "Review"){
          this.GetReviewDocuments();
        }
        else{
          if (this.Content.content.TaskType != null && this.Content.content.TaskType == "Approval"){
            this.GetApprovalDocuments();
          }
        }
      }
    }
  }

  GetReviewDocuments() {
    this.reviewService.GetReviewDocments("api/Review/ReviewDocments?Id=" + this.ReviewId).subscribe((result: any[]) => {
      if (result) {
        this.selectedDocs = [];
        this.selectedDocs = result["lstRevDocuments"];
      }
    });
  }

  GetApprovalDocuments(){
    this.reviewService.GetReviewDocuments("api/Approval/ApprovalDocments?Id=" + this.ReviewId).subscribe((result: any[] )=> {
      if (result) {
        this.selectedDocs = [];
        this.selectedDocs = result["lstApprovalDocuments"];
      }
    });  
   }

  close(){ 
    this.modalRef.close('yes');    
   }

  ResolveComments(DocID: any) {
    //ReviewDocID, ReviwID, ReviewDocs: any = null, ApplicationCode: string = null,IsOwner:boolean
    this.commonService.OnlyOfficePopupLanch(DocID, this.ReviewId,'','',true).subscribe(res=>{
      this.GetReviewDocuments();
     });  
  }

  TaskComplete(DocId: any, documentname: any, reviewtitle: any) {
    if(this.Content.content.TaskType != null && this.Content.content.TaskType == "Review"){
    this.reviewService.CheckIsLastTaskComplete("api/Review/CheckIsLastTaskComplete?ReviewId=" + this.ReviewId + "&DocId=" + DocId).subscribe(result => {
        if (result["Status"] != 1) {
        let  appCode = result["Data"].Application_Code;
        const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
        modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Review for document ' + documentname + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" }
        modalRef.result.then((result1) => {
          if (result1 == "okclick") {
            this.UpdateDocumentStatus(DocId, this.Content.content.Title, result["Status"]);
            this.GetReviewDocuments();
            //this.modalRef.close('yes');
          }
        });
      }
    });
  }
    else{
      if (this.Content.content.TaskType != null && this.Content.content.TaskType == "Approval"){
        this.reviewService.CheckIsLastTaskComplete("api/Approval/CheckIsLastTaskComplete?ApprovalId=" + this.ReviewId + "&DocId=" + DocId).subscribe(result => {
        if (result["Status"] != 1) {
        let  appCode = result["Data"].Application_Code;
        const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
        modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Approval for document ' + documentname + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" }
        modalRef.result.then((result1) => {
            if (result1 == "okclick") {
              this.UpdateApprovalDocumentStatus(DocId, this.Content.content.Title, result["Status"]);
              this.GetApprovalDocuments();
            }
          });
        }
      });
      }
    }
  }
  UpdateDocumentStatus(DocId: any, reviewtitle: any, IsLast: any) {
    if (IsLast == 2) {
      const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
      modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to Close the Review ' + reviewtitle + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" }
      modalRef.result.then((result) => {
        if (result == "okclick") {
          this.UpdateDocument_ReviewStatus(DocId);          
        }
      });
    }
    else {
      let formData = { "ReviewId":this.ReviewId ,"ReviewDocId": DocId ,"ApplicationCode":this.appCode 
        };     
        this.reviewService.UpdateDocumentStatus("api/Review/UpdateDocumentStatus", formData).subscribe(res => {
        if (res.Status == 0) {       
            this.commonService.SuccessBanner(res.Message);
            this.GetReviewDocuments();
        }
        else{
          this.commonService.ValidationBanner(res.Message);
        }    
      }); 
    }
  }

  UpdateDocument_ReviewStatus(DocId: any) {
    let formData = { "ReviewId":this.ReviewId ,"ReviewDocId": DocId ,"ApplicationCode":this.appCode 
  };     
  this.reviewService.UpdateDocument_ReviewStatus("api/Review/UpdateDocument_ReviewStatus", formData).subscribe(result => {
  if (result.Status == 0) {       
      this.commonService.SuccessBanner(result.Message);
      this.GetReviewDocuments();
  }
  else{
    this.commonService.ValidationBanner(result.Message);
  }    
}); 
}

  UpdateApprovalDocumentStatus(DocId: any, reviewtitle: any, IsLast: any) {
    if (IsLast == 2) {
      const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
      modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to Close the Approval ' + reviewtitle + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" }
      modalRef.result.then((result) => {
        if (result == "okclick") {
          this.UpdateApprovalDocument_ReviewStatus(DocId);          
        }
      });
    }
    else {
      let formData = { "ApprovalId":this.ReviewId ,"ApprovalDocId": DocId ,"ApplicationCode":this.appCode 
        };     
        this.reviewService.UpdateDocumentStatus("api/Approval/UpdateDocumentStatus", formData).subscribe(res => {
        if (res.Status == 0) {       
            this.commonService.SuccessBanner(res.Message);
            this.GetApprovalDocuments();
        }
        else{
          this.commonService.ValidationBanner(res.Message);
        }    
      }); 
    }
  }

  UpdateApprovalDocument_ReviewStatus(DocId: any) {
    let formData = { "ApprovalId":this.ReviewId ,"ApprovalDocId": DocId ,"ApplicationCode":this.appCode 
  };     
  this.reviewService.UpdateDocument_ReviewStatus("api/Approval/UpdateDocument_ApprovalStatus", formData).subscribe(result => {
    if (result.Status == 0) {       
        this.commonService.SuccessBanner(result.Message);
        this.GetApprovalDocuments();
    }
    else{
      this.commonService.ValidationBanner(result.Message);
    }    
  }); 
 }

}
